import React from 'react';
import { Modal, Button } from 'react-bootstrap';

interface Props {
  show: boolean;
  busy: boolean;
  /** What is being discontinued, e.g. "your investor registration". */
  subject: string;
  /** Who the confirmation email goes to (shown so the person knows what to expect). */
  email?: string;
  reason: string;
  onReasonChange: (value: string) => void;
  onCancel: () => void;
  onConfirm: () => void;
}

/**
 * Confirm-with-consequence modal for the two public registration landing pages
 * (introduced investor start, Service Provider user invite). Same pattern as the
 * journey-list Discontinue: plain consequence text, optional reason, red confirm.
 */
export const DiscontinueRegistrationModal: React.FC<Props> = ({
  show, busy, subject, email, reason, onReasonChange, onCancel, onConfirm,
}) => (
  <Modal
    show={show}
    onHide={busy ? () => undefined : onCancel}
    centered
    backdrop={busy ? 'static' : true}
  >
    <Modal.Header closeButton={!busy}>
      <Modal.Title className="fs-5">Discontinue registration?</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <p className="small mb-2">
        {`This stops ${subject} here. No account will be created and nothing further is required from you.`}
      </p>
      <p className="small text-muted mb-3">
        {email
          ? `We will email a confirmation to ${email}. `
          : 'We will email you a confirmation. '}
        If you change your mind later, this same link will still work.
      </p>
      <label className="small fw-semibold mb-1" htmlFor="discontinueReason">Reason (optional)</label>
      <textarea
        id="discontinueReason"
        className="form-control"
        rows={2}
        maxLength={500}
        value={reason}
        onChange={(e) => onReasonChange(e.target.value)}
        placeholder="Tell us why you are not proceeding (optional)"
        disabled={busy}
      />
    </Modal.Body>
    <Modal.Footer>
      {!busy && (
        <Button variant="outline-secondary" size="sm" onClick={onCancel}>
          Go back
        </Button>
      )}
      <Button variant="danger" size="sm" onClick={onConfirm} disabled={busy}>
        {busy ? 'Discontinuing…' : 'Yes, discontinue'}
      </Button>
    </Modal.Footer>
  </Modal>
);

export default DiscontinueRegistrationModal;
